























































import {Component, Provide, Vue, Watch} from 'vue-property-decorator';
import {Action, State} from 'vuex-class';
import axios from 'axios';
import {baseUrlAPI} from '@/globals';
import ErrorNotifier from '@/domain/util/notifications/ErrorNotifier';
import SuccessNotifier from '@/domain/util/notifications/SuccessNotifier';
import HomeFooter from '@/components/common/home/HomeFooter.vue';
import Router from '@/router';

@Component({components: {HomeFooter}})
export default class ResetPassword extends Vue {

    @Provide()
    public date = new Date();

    @Provide()
    public isLoad = false;

    @Provide()
    public autoRedirectSeconds = -1;

    @Provide()
    public email = '';

    @Provide() public fields: any;

    public isDisabled() {
        return !Object.keys(this.fields).every((key) => this.fields[key].valid);
    }

    public async forgot_password() {
        this.isLoad = true;
        try {
            const result = await axios.post(`${baseUrlAPI}forgot_password`, { login: this.email });
            if (result.status === 200) {
                SuccessNotifier.notify('Пароль обновлен', 'Новый пароль отправлен Вам на электронную почту');
                this.autoRedirectSeconds = 10;
                setTimeout(this.tick, 1000);
            } else {
                ErrorNotifier.notifyWithCustomMessage('Пользователь не найден, удостоверьтесь что правильно указали логин');
            }
        } catch {
            ErrorNotifier.notifyWithCustomMessage('Пользователь не найден, удостоверьтесь что правильно указали логин');
        }
        this.isLoad = false;
    }

    public tick() {
        if (this.autoRedirectSeconds === 1) {
            Router.push({name: 'home'});
            return;
        }
        this.autoRedirectSeconds--;
        setTimeout(this.tick, 1000);
    }

}
